import { Dispatch, MutableRefObject, SetStateAction, useEffect, useRef, useState } from 'react';

interface Position {
  x: number;
  y: number;
}

interface UseBookingMapStageStateParams {
  initialScale?: number;
}

interface UseBookingMapStageStateApi {
  stagePosition: Position;
  stageScale: number;
  stagePositionRef: MutableRefObject<Position>;
  stageScaleRef: MutableRefObject<number>;
  setStagePosition: Dispatch<SetStateAction<Position>>;
  setStageScale: Dispatch<SetStateAction<number>>;
}

const DEFAULT_INITIAL_SCALE = 0.6;

export const useBookingMapStageState = (params: UseBookingMapStageStateParams = {}): UseBookingMapStageStateApi => {
  const { initialScale = DEFAULT_INITIAL_SCALE } = params;

  const [stagePosition, setStagePosition] = useState<Position>({ x: 0, y: 0 });
  const [stageScale, setStageScale] = useState<number>(initialScale);
  const stagePositionRef = useRef<Position>({ x: 0, y: 0 });
  const stageScaleRef = useRef<number>(initialScale);

  useEffect(() => {
    stagePositionRef.current = stagePosition;
  }, [stagePosition]);

  useEffect(() => {
    stageScaleRef.current = stageScale;
  }, [stageScale]);

  return {
    stagePosition,
    stageScale,
    stagePositionRef,
    stageScaleRef,
    setStagePosition,
    setStageScale,
  };
};
